(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[128],{

/***/ "2B1m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hero; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("1JJ2");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("sRdV");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_countdown_Countdown__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("mmhe");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_heading_Heading__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("3jv5");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("qqKu");
/* harmony import */ var _tracking_utils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("zwLB");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("829J");
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("EkOT");
/* harmony import */ var _tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("DqI1");
/* harmony import */ var _heroUtils__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("5xkM");













var __jsx = react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/no-danger */
















var Hero = function Hero(_ref) {
  var alt = _ref.alt,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"] : _ref$as,
      _ref$backgroundURLDes = _ref.backgroundURLDesktop,
      backgroundURLDesktop = _ref$backgroundURLDes === void 0 ? '' : _ref$backgroundURLDes,
      _ref$backgroundURLMob = _ref.backgroundURLMobile,
      backgroundURLMobile = _ref$backgroundURLMob === void 0 ? '' : _ref$backgroundURLMob,
      className = _ref.className,
      contentPosition = _ref.contentPosition,
      countdown = _ref.countdown,
      hasOverlap = _ref.hasOverlap,
      _ref$hLevel = _ref.hLevel,
      hLevel = _ref$hLevel === void 0 ? 1 : _ref$hLevel,
      link = _ref.link,
      icon = _ref.icon,
      id = _ref.id,
      _ref$isImmersive = _ref.isImmersive,
      isImmersive = _ref$isImmersive === void 0 ? false : _ref$isImmersive,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      style = _ref.style,
      subtitle = _ref.subtitle,
      _ref$theming = _ref.theming,
      theming = _ref$theming === void 0 ? {} : _ref$theming,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      trackingData = _ref.trackingData,
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? '' : _ref$url;
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_17__[/* useTracking */ "a"])();

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_16__[/* useResponsive */ "b"])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var _useRouter = Object(next_router__WEBPACK_IMPORTED_MODULE_24__["useRouter"])(),
      asPath = _useRouter.asPath;

  var _useTrackEvent = Object(_tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_27__[/* useTrackEvent */ "a"])(),
      trackEvent = _useTrackEvent.trackEvent;

  var _usePageContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_26__[/* usePageContext */ "b"])(),
      siteSection = _usePageContext.siteSection; // just in case, you know, someone forgets to set one or something
  // mobile is default because Mobile First™
  // we're keeping the support for the legacy url prop for backwards compat
  // i.e. with ImmersiveSlideshow, as providing only a desktop url or a mobile one is pretty awkward


  var _generateBackgroundSt = Object(_heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* generateBackgroundStylesAndClassName */ "d"])({
    backgroundURLDesktop: backgroundURLDesktop || url,
    backgroundURLMobile: backgroundURLMobile || url
  }),
      styleTag = _generateBackgroundSt.style,
      imageClassName = _generateBackgroundSt.className;

  var _theming$titleColor = theming.titleColor,
      titleColor = _theming$titleColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE : _theming$titleColor,
      _theming$subtitleColo = theming.subtitleColor,
      subtitleColor = _theming$subtitleColo === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE : _theming$subtitleColo,
      _theming$countdownCol = theming.countdownColor,
      countdownColor = _theming$countdownCol === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE : _theming$countdownCol,
      _theming$linkColor = theming.linkColor,
      linkColor = _theming$linkColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].BLACK : _theming$linkColor,
      _theming$linkBackgrou = theming.linkBackgroundColor,
      linkBackgroundColor = _theming$linkBackgrou === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].SAFFRON : _theming$linkBackgrou;

  var _getHeroDimensions = Object(_heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* getHeroDimensions */ "e"])(size),
      heightClassName = _getHeroDimensions.heightClassName,
      paddingBottomClassName = _getHeroDimensions.paddingBottomClassName,
      paddingTopClassName = _getHeroDimensions.paddingTopClassName;

  var isHighlight = size === 'highlightSmall' || size === 'highlight';
  var textAlignment = contentPosition ? _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* TITLE_POSITIONS */ "c"][contentPosition] : _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* TITLE_POSITIONS */ "c"]['bottom-left'];
  var horizontalAlignment = contentPosition ? contentPosition.split('-')[1] : '';
  var linkSpacing = horizontalAlignment ? _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* LINK_SPACINGS */ "b"][horizontalAlignment] : '';

  var tracking = _objectSpread({
    actionGA: 'immersive',
    labelGA: "".concat(title).trim()
  }, trackingData);

  var TitleAndSubtitleWrapperTag = (link === null || link === void 0 ? void 0 : link.url) ? as : react__WEBPACK_IMPORTED_MODULE_13__["Fragment"];
  var titleAndSubtitleWrapperProps = (link === null || link === void 0 ? void 0 : link.url) ? {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('inline-block transform transition-all duration-250 ease-in hover:scale-105', linkSpacing),
    'data-testid': isImmersive ? 'immersive-text' : undefined,
    onClick: function onClick() {
      return track(tracking);
    },
    url: link.url
  } : {};

  var getTitleAndSubtitleWrapperProps = function getTitleAndSubtitleWrapperProps() {
    if (!(link === null || link === void 0 ? void 0 : link.url)) {
      return;
    }

    if (as === 'a') {
      return _objectSpread(_objectSpread({}, titleAndSubtitleWrapperProps), {}, {
        href: link === null || link === void 0 ? void 0 : link.url
      });
    }

    return _objectSpread(_objectSpread({}, titleAndSubtitleWrapperProps), {}, {
      url: link === null || link === void 0 ? void 0 : link.url
    });
  };

  var buttonTrack = function buttonTrack(trackingPayload) {
    var isPBFLanding = Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_23__[/* isPBFLandingPage */ "m"])(asPath);

    if (siteSection === 'Shopping_Landing' && isPBFLanding) {
      trackEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_25__[/* TRACK_EVENT_NAMES */ "F"].CLICK_PREBOOKING_FORM_PREREG, {
        detail_click: 'check_my_request'
      });
    } else {
      track && track(trackingPayload);
    }
  };

  var displayIcon = isDesktop ? icon === null || icon === void 0 ? void 0 : icon.displayDesktop : icon === null || icon === void 0 ? void 0 : icon.displayMobile;
  var iconLink = (isTablet ? icon === null || icon === void 0 ? void 0 : icon.linkDesktop : icon === null || icon === void 0 ? void 0 : icon.linkMobile) || (icon === null || icon === void 0 ? void 0 : icon.linkMobile) || (icon === null || icon === void 0 ? void 0 : icon.linkDesktop); // hey isn't that the same logic that we used up there for the imageUrl?
  // yes it is!

  return __jsx("div", {
    "aria-label": alt,
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])(heightClassName, className),
    "data-size": size,
    "data-testid": "Hero",
    id: id,
    role: "img",
    style: style
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('relative', heightClassName, paddingTopClassName)
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('animation-duration-500 absolute inset-x-0 top-0 h-full w-full animate-fadeIn bg-cover bg-center bg-no-repeat', imageClassName, heightClassName)
  }), icon && displayIcon && iconLink && __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])(paddingTopClassName, 'absolute inset-0', {
      'pb-40': hasOverlap
    })
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('m-auto flex h-full w-full max-w-site overflow-hidden p-20', isTablet ? _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* ICON_POSITIONS */ "a"][icon.positionDesktop] : _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* ICON_POSITIONS */ "a"][icon.positionMobile]),
    dir: "ltr"
  }, __jsx("img", {
    alt: icon.alt || '',
    className: "max-h-full flex-none",
    src: iconLink,
    style: {
      width: isTablet ? "calc(".concat(icon.desktopWidth, " / 1180 * 100vw)") : "calc(".concat(icon.mobileWidth, " / 375 * 100vw)"),
      maxWidth: isTablet ? icon.desktopWidth : icon.mobileWidth
    }
  }))), !!title && __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])(paddingBottomClassName, 'relative z-1 flex h-full flex-col px-20 pt-10 align-bottom')
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])("mx-auto flex w-full max-w-site flex-col ".concat(textAlignment))
  }, __jsx(TitleAndSubtitleWrapperTag, getTitleAndSubtitleWrapperProps(), __jsx(_frameworks_heading_Heading__WEBPACK_IMPORTED_MODULE_21__[/* Heading */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])("text-".concat(titleColor), {
      'lg:text-48': !isHighlight && size !== 'small',
      'text-shadow-3': titleColor === _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE
    }),
    hLevel: hLevel,
    theme: "heading-brand-1"
  }, title), !!subtitle && __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_22__[/* Text */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('mt-5 font-bold text-shadow-3 md:text-16', "text-".concat(subtitleColor)),
    text: subtitle,
    theme: "text-sans-n1"
  })), !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default()(countdown) && __jsx(_frameworks_countdown_Countdown__WEBPACK_IMPORTED_MODULE_19__[/* Countdown */ "a"], {
    className: "py-10",
    color: countdownColor,
    dateTimeEnd: countdown.dateTimeEnd,
    days: countdown.days,
    hours: countdown.hours,
    minutes: countdown.minutes,
    seconds: countdown.seconds
  }), (link === null || link === void 0 ? void 0 : link.label) && __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])({
      'mt-auto': isHighlight
    })
  }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_18__[/* Button */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('mt-15 md:mt-0', {
      'w-full': !isDesktop
    }, isHighlight && !isDesktop ? 'max-w-none' : 'max-w-280'),
    color: linkColor,
    colorBg: linkBackgroundColor,
    "data-testid": isImmersive ? 'immersive-button' : undefined,
    isExternalLink: isImmersive,
    onClick: function onClick() {
      return buttonTrack(tracking);
    },
    url: link.url || '#hero-beacon'
  }, link.label)))), __jsx("style", {
    dangerouslySetInnerHTML: {
      __html: styleTag
    }
  }), title && __jsx("div", {
    className: "absolute inset-0 bg-[linear-gradient(to_bottom,rgba(0,0,0,0)_0%,rgba(0,0,0,0.2)_100%)]"
  })), __jsx("div", {
    id: "hero-beacon"
  }));
};

/***/ }),

/***/ "3jv5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Heading_Heading; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-markdown/lib/react-markdown.js
var react_markdown = __webpack_require__("VqYj");
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);

// EXTERNAL MODULE: /opt/webapp/node_modules/remark-breaks/index.js
var remark_breaks = __webpack_require__("l24s");
var remark_breaks_default = /*#__PURE__*/__webpack_require__.n(remark_breaks);

// EXTERNAL MODULE: ./src/client/components/utils/markdown/markdown.js
var markdown = __webpack_require__("ZMpj");

// CONCATENATED MODULE: ./src/client/components/frameworks/heading/Heading.themes.js
var themes = {
  none: {
    thRoot: ''
  },
  'heading-brand-1': {
    thRoot: 'text-black font-brand text-32 leading-tight'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/heading/Heading.jsx









var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var MARKDOWN_ALLOWED_TYPES = [markdown["a" /* HTML_ELEMENTS */].BREAK.type, markdown["a" /* HTML_ELEMENTS */].EMPHASIS.type, markdown["a" /* HTML_ELEMENTS */].PARAGRAPH.type, markdown["a" /* HTML_ELEMENTS */].STRONG.type, markdown["a" /* HTML_ELEMENTS */].TEXT.type];

var HeadingText = function HeadingText(_ref) {
  var children = _ref.children;
  return children;
};

var Heading_Heading = function Heading(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$hLevel = _ref2.hLevel,
      hLevel = _ref2$hLevel === void 0 ? 1 : _ref2$hLevel,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'heading-brand-1' : _ref2$theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref2, ["children", "className", "hLevel", "theme"]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var thRoot = themes[theme].thRoot;
  return __jsx(react_markdown_default.a, {
    allowedTypes: MARKDOWN_ALLOWED_TYPES,
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    plugins: [remark_breaks_default.a],
    renderers: {
      root: Object(markdown["c" /* markdownRootHeadingRenderer */])(_objectSpread(_objectSpread({}, rest), {}, {
        hLevel: hLevel
      })),
      paragraph: HeadingText
    }
  }, children);
};

/***/ }),

/***/ "5xkM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ICON_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LINK_SPACINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TITLE_POSITIONS; });
/* unused harmony export SIZES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getHeroDimensions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return generateBackgroundStylesAndClassName; });
/* unused harmony export getBackgroundImageUrl */
/* unused harmony export getBackgroundRule */
/* unused harmony export getAllBackgroundRules */
/* unused harmony export AUTO */
/* unused harmony export PREFIXES */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var _utils_media_server__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("FLQK");
/* harmony import */ var _utils_media_server_dictionary__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("lDxO");
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("m1JM");











function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var AUTO = '_AUTOFORMAT_';
var PREFIXES = ['webkit', 'moz', 'o', 'ms'];

var getBackgroundImageUrl = function getBackgroundImageUrl(url, width) {
  var options = {
    format: AUTO,
    url: url,
    width: width,
    height: 'auto',
    transform: 'resize',
    quality: 70
  };
  return _utils_media_server__WEBPACK_IMPORTED_MODULE_10__[/* getUrl */ "a"](options);
};

var getBackgroundRule = function getBackgroundRule(params) {
  return function (getUrlFunction) {
    return function (prefixes) {
      var id = params.id,
          url = params.url,
          width1x = params.width1x,
          width2x = params.width2x;
      return ".".concat(id, " {\n        background-image:url(").concat(getUrlFunction(url, width1x), ");\n        ").concat(prefixes.reduce(function (acc, prefix) {
        return "".concat(acc, "\n        background-image: -").concat(prefix, "-image-set(url(").concat(getUrlFunction(url, width1x), ") 1x, url(").concat(getUrlFunction(url, width2x), ") 2x);\n        ");
      }, ''), "\n      }");
    };
  };
};

var getAllBackgroundRules = function getAllBackgroundRules(params) {
  return function (getRuleFunction) {
    return "".concat(getRuleFunction(params)(getBackgroundImageUrl)(PREFIXES));
  };
};

var ICON_POSITIONS = {
  'top-left': 'items-start justify-start',
  'top-middle': 'items-start justify-center',
  'top-right': 'items-start justify-end',
  'center-left': 'items-center justify-start',
  'center-middle': 'items-center justify-center',
  'center-right': 'items-center justify-end',
  'bottom-left': 'items-end justify-start',
  'bottom-middle': 'items-end justify-center',
  'bottom-right': 'items-end justify-end'
};
var LINK_SPACINGS = {
  left: 'md:p-30 md:-ms-30',
  middle: 'md:p-30',
  right: 'md:p-30 md:-me-30'
};
var TITLE_POSITIONS = {
  'top-left': 'mb-auto items-start text-start',
  'top-middle': 'mb-auto items-center text-center',
  'top-right': 'mb-auto items-end text-end',
  'center-left': 'my-auto items-start text-start',
  'center-middle': 'my-auto items-center text-center',
  'center-right': 'my-auto items-end text-end',
  'bottom-left': 'mt-auto items-start text-start',
  'bottom-middle': 'mt-auto items-center text-center',
  'bottom-right': 'mt-auto items-end text-end'
};
var SIZES = {
  small: {
    mobile: {
      height: '220px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '340px',
      paddingBottom: '80px'
    }
  },
  highlightSmall: {
    mobile: {
      height: '220px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '340px',
      paddingBottom: '80px'
    }
  },
  medium: {
    mobile: {
      height: '320px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '440px',
      paddingBottom: '100px'
    }
  },
  large: {
    mobile: {
      height: '420px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '540px',
      paddingBottom: '115px'
    }
  },
  highlight: {
    mobile: {
      height: '480px',
      paddingBottom: '40px'
    },
    desktop: {
      height: '480px',
      paddingBottom: '70px'
    }
  },
  full: {
    mobile: {
      height: '100%',
      paddingBottom: '60px'
    },
    desktop: {
      height: '100%',
      paddingBottom: '115px'
    }
  }
};
var getHeroDimensions = function getHeroDimensions(sizeProp) {
  var isHighlight = sizeProp === 'highlightSmall' || sizeProp === 'highlight';
  return {
    heightClassName: "immersiveHeight--".concat(sizeProp),
    paddingBottomClassName: "immersivePaddingBottom--".concat(sizeProp),
    paddingTopClassName: isHighlight ? 'immersivePaddingTop--highlight' : 'immersivePaddingTop'
  };
};
var generateBackgroundStylesAndClassName = function generateBackgroundStylesAndClassName(_ref) {
  var backgroundURLDesktop = _ref.backgroundURLDesktop,
      backgroundURLMobile = _ref.backgroundURLMobile;

  if (!backgroundURLDesktop && !backgroundURLMobile) {
    return {
      style: '',
      className: ''
    };
  }

  var url = backgroundURLDesktop || backgroundURLMobile;
  var componentId = Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_12__[/* generateUniqueId */ "b"])([url]);
  var widths = _utils_media_server_dictionary__WEBPACK_IMPORTED_MODULE_11__[/* defaultDictionnary */ "a"].getWidthRanges();
  var params = {
    id: componentId,
    url: url
  };
  var mobileUrl = backgroundURLMobile || backgroundURLDesktop;
  return {
    className: componentId,
    style: "".concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      url: mobileUrl,
      width1x: widths[1],
      width2x: widths[2]
    }))(getBackgroundRule), "\n      @media all and (min-width: 22.51em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      url: mobileUrl,
      width1x: widths[2],
      width2x: widths[5]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 40.01em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[3],
      width2x: widths[5]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 64.01em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[5],
      width2x: widths[6]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 76.26em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[6],
      width2x: widths[6]
    }))(getBackgroundRule), "\n      }")
  };
};


/***/ }),

/***/ "7x6O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Zoom; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1JJ2");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("0IQ5");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("qBqs");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var DIMENSIONS = {
  w: 'auto',
  h: 'auto'
};
var Zoom = function Zoom(_ref) {
  var imageUrl = _ref.imageUrl,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt,
      _ref$hint = _ref.hint,
      hint = _ref$hint === void 0 ? '' : _ref$hint,
      inert = _ref.inert;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_1__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop,
      isRTL = _useResponsive.isRTL;

  var scrollArea = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])(null);
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (isRTL && (scrollArea === null || scrollArea === void 0 ? void 0 : scrollArea.current)) {
      scrollArea.current.scrollLeft = scrollArea.current.scrollWidth;
    }
  });
  return __jsx("div", {
    className: "direction-ltr relative h-400 lg:h-full"
  }, hint && !isDesktop && __jsx("span", {
    className: "absolute inset-x-0 top-0 mt-20 flex items-center justify-center gap-5 px-10 font-brand text-14 leading-0 text-saffron"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_3__[/* Icon */ "a"], {
    width: "1.25rem",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].LIGHTBULB
  }), __jsx("span", {
    className: "leading-1"
  }, hint)), __jsx("div", {
    onTouchStart: function onTouchStart(e) {
      return inert ? e.stopPropagation() : null;
    },
    onTouchMove: function onTouchMove(e) {
      return inert ? e.stopPropagation() : null;
    },
    onTouchEnd: function onTouchEnd(e) {
      return inert ? e.stopPropagation() : null;
    },
    className: "flex h-full w-full items-center justify-start overflow-x-scroll",
    ref: scrollArea
  }, __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_2__[/* Image */ "a"], {
    classNameImg: "max-w-initial max-h-initial h-full",
    hasLazyLoading: false,
    imageUrl: imageUrl,
    altMsg: alt,
    dimensions: DIMENSIONS,
    fullscreen: true,
    transformation: "resize",
    className: "h-full py-20 pt-60 sm:mx-auto lg:p-0"
  })));
};

/***/ }),

/***/ "DQFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageSlideShow; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("u/u4");
/* harmony import */ var _arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Gy6l");
/* harmony import */ var _backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("NZxu");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("0IQ5");
/* harmony import */ var _slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("A5Hi");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;








var ImageSlideShow = function ImageSlideShow(_ref) {
  var centerPadding = _ref.centerPadding,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      fadeUnseenItems = _ref.fadeUnseenItems,
      galleryLabel = _ref.galleryLabel,
      _ref$groupKey = _ref.groupKey,
      groupKey = _ref$groupKey === void 0 ? 'thumbnails' : _ref$groupKey,
      hasFullScreenMode = _ref.hasFullScreenMode,
      hasOverlappingControls = _ref.hasOverlappingControls,
      hasOverlappingClick = _ref.hasOverlappingClick,
      hasInfiniteScroll = _ref.hasInfiniteScroll,
      hasLazyLoading = _ref.hasLazyLoading,
      itemClassName = _ref.itemClassName,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      _ref$nbItemsToShow = _ref.nbItemsToShow,
      nbItemsToShow = _ref$nbItemsToShow === void 0 ? 1 : _ref$nbItemsToShow,
      nextLabel = _ref.nextLabel,
      onChangeIndex = _ref.onChangeIndex,
      previousLabel = _ref.previousLabel,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_5__[/* default */ "c"].XL : _ref$ratio,
      _ref$ratioDisplay = _ref.ratioDisplay,
      ratioDisplay = _ref$ratioDisplay === void 0 ? 1 : _ref$ratioDisplay,
      _ref$spacerWidth = _ref.spacerWidth,
      spacerWidth = _ref$spacerWidth === void 0 ? 0 : _ref$spacerWidth;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(false),
      isFullScreen = _useState[0],
      setIsFullScreen = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(0),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    if (onChangeIndex) {
      onChangeIndex(activeIndex);
    }
  }, [activeIndex]);

  if (!media.length) {
    return null;
  }

  var updateActiveIndex = function updateActiveIndex(index) {
    setActiveIndex(index);
  };

  var gk = hasFullScreenMode ? null : groupKey;
  var items = media.filter(function (_ref2) {
    var src = _ref2.src;
    return Boolean(src);
  }).map(function (_ref3) {
    var _ref3$alt = _ref3.alt,
        alt = _ref3$alt === void 0 ? '' : _ref3$alt,
        _onClick = _ref3.onClick,
        src = _ref3.src;

    var children = __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_8__[/* default */ "b"], {
      altMsg: alt,
      className: itemClassName,
      groupKey: gk,
      hasLazyLoading: hasLazyLoading,
      imageUrl: src,
      key: src,
      ratioKey: ratio,
      ratioDisplay: ratioDisplay,
      spacerWidth: ratioDisplay
    });

    var isButton = hasFullScreenMode || _onClick;
    return __jsx(react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], {
      key: "Image-".concat(src)
    }, isButton ? __jsx("button", {
      className: "block h-full w-full",
      onClick: function onClick() {
        _onClick && _onClick();

        if (hasFullScreenMode) {
          setIsFullScreen(true);
        }
      },
      type: "button"
    }, children) : __jsx("div", {
      className: "h-full"
    }, children));
  });
  return __jsx(_slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_9__[/* SliderHandler */ "a"], {
    centerPadding: centerPadding,
    fadeUnseenItems: fadeUnseenItems,
    hasInfiniteScroll: hasInfiniteScroll,
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: items,
    nbItemsToShow: nbItemsToShow,
    onChangeIndex: updateActiveIndex,
    spacerWidth: spacerWidth
  }, function (_ref4) {
    var hasControls = _ref4.hasControls,
        isNextControlDisabled = _ref4.isNextControlDisabled,
        isPreviousControlDisabled = _ref4.isPreviousControlDisabled,
        itemsNode = _ref4.itemsNode,
        onNext = _ref4.onNext,
        onPrevious = _ref4.onPrevious;
    return __jsx("div", {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('group relative', className)
    }, itemsNode, hasControls && __jsx("div", {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('pointer-events-none absolute inset-0 z-2 m-auto flex w-full items-center justify-between transition-opacity duration-250 ease-in will-change-transform', {
        'px-10 sm:px-20': !hasOverlappingControls
      }),
      "data-testid": "ImageSlideShow-controls-parent"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('pointer-events-auto z-2 me-auto shadow-sm', {
        '-translate-x-1/2 transform': hasOverlappingControls
      }),
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: previousLabel,
      onClick: function onClick(event) {
        onPrevious(event);

        if (hasOverlappingClick) {
          event === null || event === void 0 ? void 0 : event.stopPropagation();
        }
      }
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('pointer-events-auto z-2 ms-auto shadow-sm', {
        'translate-x-1/2 transform': hasOverlappingControls
      }),
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: nextLabel,
      onClick: function onClick(event) {
        onNext(event);

        if (hasOverlappingClick) {
          event === null || event === void 0 ? void 0 : event.stopPropagation();
        }
      },
      rotation: 180
    })), hasFullScreenMode && isFullScreen && __jsx(_backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_7__[/* Backdrop */ "a"], {
      ariaLabel: galleryLabel,
      closeLabel: closeLabel,
      hasCloseButton: true,
      onClose: function onClose() {
        return setIsFullScreen(false);
      }
    }, __jsx("div", {
      className: "relative w-full"
    }, itemsNode, hasControls && __jsx("div", {
      className: "pointer-events-none absolute inset-0 m-auto flex w-full items-center justify-between px-10 sm:px-20"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: "pointer-events-auto z-2 me-auto shadow-sm",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: previousLabel,
      onClick: function onClick(event) {
        onPrevious(event);

        if (hasOverlappingClick) {
          event === null || event === void 0 ? void 0 : event.stopPropagation();
        }
      }
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: "pointer-events-auto z-2 ms-auto shadow-sm",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: nextLabel,
      onClick: function onClick(event) {
        onNext(event);

        if (hasOverlappingClick) {
          event === null || event === void 0 ? void 0 : event.stopPropagation();
        }
      },
      rotation: 180
    })))));
  });
};

/***/ }),

/***/ "HKmi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StreetView; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hNT8");
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_google_google_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("UlIv");



var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;




var GoogleMapReact = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 3).then(__webpack_require__.t.bind(null, "h6Ot", 7));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("h6Ot")];
    },
    modules: ['google-map-react']
  }
});

var addStreetView = function addStreetView(_ref) {
  var hideFloorControls = _ref.hideFloorControls,
      map = _ref.map,
      maps = _ref.maps,
      position = _ref.position,
      pov = _ref.pov,
      ref = _ref.ref;
  var panorama = new maps.StreetViewPanorama(ref, {
    addressControl: true,
    addressControlOptions: {
      position: maps.ControlPosition.TOP_LEFT
    },
    disableDefaultUI: hideFloorControls,
    fullscreenControl: false,
    position: position,
    pov: pov,
    linksControl: true,
    panControl: true,
    zoomControl: true
  });
  map.setStreetView(panorama);
};

function StreetView(props) {
  var _props$fov = props.fov,
      fov = _props$fov === void 0 ? 2 : _props$fov,
      _props$heading = props.heading,
      heading = _props$heading === void 0 ? 2 : _props$heading,
      _props$hideFloorContr = props.hideFloorControls,
      hideFloorControls = _props$hideFloorContr === void 0 ? false : _props$hideFloorContr,
      latitude = props.latitude,
      longitude = props.longitude;

  var _map = Object(react__WEBPACK_IMPORTED_MODULE_4__["useRef"])();

  var coordinates = {
    lat: latitude,
    lng: longitude
  };
  return __jsx("div", {
    className: "h-full",
    "data-testid": "StreetViewComponent",
    ref: _map
  }, __jsx(GoogleMapReact, {
    bootstrapURLKeys: {
      key: _config__WEBPACK_IMPORTED_MODULE_5___default.a.get(_utils_google_google_constants__WEBPACK_IMPORTED_MODULE_6__[/* GOOGLE_API_KEY */ "c"])
    },
    defaultCenter: coordinates,
    defaultZoom: fov,
    onGoogleApiLoaded: function onGoogleApiLoaded(_ref2) {
      var map = _ref2.map,
          maps = _ref2.maps;
      return addStreetView({
        hideFloorControls: hideFloorControls,
        map: map,
        maps: maps,
        position: coordinates,
        pov: {
          heading: heading,
          pitch: 0
        },
        // same here, for now
        ref: _map.current
      });
    },
    yesIWantToUseGoogleMapApiInternals: true
  }));
}

/***/ }),

/***/ "JhHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVideoUrl; });
/* unused harmony export getVideoThumbnail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isVideoUrl; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("iKE+");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_4__);





var youtubeRegEx = new RegExp('https://(?:youtu.be/|www.youtube.com/(?:watch\\?v=|embed/))([a-zA-Z0-9_-]+)');
var youkuRegEx = new RegExp('https?://(?:player.youku.com/embed/|player.youku.com/player.php/sid/)([a-zA-Z0-9]+)');

function getYoutubeVideoUrl(url) {
  var urlId = youtubeRegEx.exec(url);
  return urlId ? "https://www.youtube.com/embed/".concat(urlId[1]) : null;
}

function getYoutubeThumbnail(url) {
  var urlId = youtubeRegEx.exec(url);
  return urlId ? "https://img.youtube.com/vi/".concat(urlId[1], "/sddefault.jpg") : null;
}

function getYoukuVideoUrl(url) {
  var urlId = youkuRegEx.exec(url);
  var clientId = _config__WEBPACK_IMPORTED_MODULE_4___default.a.get('youku.clientId');
  return urlId ? "https://player.youku.com/embed/".concat(urlId[1], "?client_id=").concat(clientId) : null;
}

function getVideoUrl(url) {
  return getYoutubeVideoUrl(url) || getYoukuVideoUrl(url);
}

function getVideoThumbnail(url) {
  return getYoutubeThumbnail(url);
}

function isVideoUrl(url) {
  return youtubeRegEx.test(url) || youkuRegEx.test(url);
}



/***/ }),

/***/ "Nn0M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/widgets/immersive-slideshow/ImmersiveSlideShow.jsx + 5 modules
var ImmersiveSlideShow = __webpack_require__("r+bv");

// EXTERNAL MODULE: ./src/client/components/widgets/multimedia/Multimedia.jsx + 7 modules
var Multimedia = __webpack_require__("h3D+");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// CONCATENATED MODULE: ./src/client/components/widgets/product-immersive/product-immersive-narrow/ProductImmersiveNarrow.jsx
var __jsx = react_default.a.createElement;


var ProductImmersiveNarrow_ProductImmersiveNarrow = function ProductImmersiveNarrow(_ref) {
  var media = _ref.media,
      nextLabel = _ref.nextLabel,
      pictureAltLabel = _ref.pictureAltLabel,
      previousLabel = _ref.previousLabel,
      size = _ref.size;
  return __jsx(ImmersiveSlideShow["a" /* ImmersiveSlideShow */], {
    immersiveSize: size,
    media: media,
    nextLabel: nextLabel,
    pictureAltLabel: pictureAltLabel,
    previousLabel: previousLabel
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-immersive/ProductImmersive.jsx

var ProductImmersive_jsx = react_default.a.createElement;








var ProductImmersive_ProductImmersive = function ProductImmersive(_ref) {
  var className = _ref.className,
      closeLabel = _ref.closeLabel,
      galleryLabel = _ref.galleryLabel,
      id = _ref.id,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      multimedia = _ref.multimedia,
      multimediaLabels = _ref.multimediaLabels,
      nextLabel = _ref.nextLabel,
      openGalleryLabel = _ref.openGalleryLabel,
      pictureAltLabel = _ref.pictureAltLabel,
      previousLabel = _ref.previousLabel,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  if (!media.length) {
    return null;
  }

  var multimediaStyle = isDesktop ? {
    bottom: '45px'
  } : {
    bottom: '80px'
  };
  return ProductImmersive_jsx("div", Object(esm_extends["a" /* default */])({
    className: Object(classnames_utils["a" /* classnames */])('relative', className),
    style: appContext.isSeller ? {
      top: "-".concat(Navigation_constants["d" /* heights */].NAVIGATION_LARGE_HEIGHT, "px")
    } : {},
    "data-testid": "immersive"
  }, id ? {
    id: id
  } : null), isDesktop ? ProductImmersive_jsx(ImmersiveSlideShow["a" /* ImmersiveSlideShow */], {
    immersiveSize: size,
    media: media,
    nextLabel: nextLabel,
    pictureAltLabel: pictureAltLabel,
    previousLabel: previousLabel
  }) : ProductImmersive_jsx(ProductImmersiveNarrow_ProductImmersiveNarrow, {
    media: media,
    nextLabel: nextLabel,
    pictureAltLabel: pictureAltLabel,
    previousLabel: previousLabel,
    size: size
  }), ProductImmersive_jsx("div", {
    className: "absolute ms-20 lg:mx-0 lg:w-full",
    style: multimediaStyle
  }, ProductImmersive_jsx(Multimedia["a" /* Multimedia */], {
    closeLabel: closeLabel,
    galleryLabel: galleryLabel,
    isOverlay: true,
    labels: multimediaLabels,
    medias: multimedia,
    nextLabel: nextLabel,
    openGalleryLabel: openGalleryLabel,
    pictureAltLabel: pictureAltLabel,
    previousLabel: previousLabel,
    theme: isDesktop ? 'overlay' : 'overlayCompact'
  })));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-immersive-line/ProductImmersiveLine.jsx

var ProductImmersiveLine_jsx = react_default.a.createElement;



var ProductImmersiveLine_ProductImmersiveLine = function ProductImmersiveLine(_ref) {
  var config = _ref.config,
      id = _ref.id,
      media = _ref.media,
      resort = _ref.resort;

  if (!resort) {
    return null;
  }

  var _resort$images = resort.images,
      images = _resort$images === void 0 ? [] : _resort$images,
      name = resort.name;
  Object(i18n["a" /* addTranslationKeys */])(config);
  var galleryLabel = name ? Object(i18n["h" /* t */])('common.galleries.productGallery', {
    productName: name
  }) : Object(i18n["h" /* t */])('common.galleries.gallery');
  var nextLabel = name ? Object(i18n["h" /* t */])('common.galleries.productNextPicture', {
    productName: name
  }) : Object(i18n["h" /* t */])('common.next');
  var previousLabel = name ? Object(i18n["h" /* t */])('common.galleries.productPreviousPicture', {
    productName: name
  }) : Object(i18n["h" /* t */])('common.previous');
  var pictureAltLabel = Object(i18n["h" /* t */])('common.galleries.productPictureItem', {
    total: images.length,
    productName: name
  });
  return ProductImmersiveLine_jsx(ProductImmersive_ProductImmersive, {
    className: "Line Line-Immersive",
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    galleryLabel: galleryLabel,
    id: id,
    key: resort.id,
    media: images,
    multimedia: media,
    multimediaLabels: {
      photos: Object(i18n["h" /* t */])('common.photoTitle'),
      videos: Object(i18n["h" /* t */])('common.videoTitle'),
      videos360: Object(i18n["h" /* t */])('common.video360Title')
    },
    nextLabel: nextLabel,
    openGalleryLabel: Object(i18n["h" /* t */])('common.galleries.openSlideShowGallery'),
    pictureAltLabel: pictureAltLabel,
    previousLabel: previousLabel
  });
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-immersive/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ProductImmersiveLine_ProductImmersiveLine);

/***/ }),

/***/ "RYcy":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("m2YG");

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

module.exports = isInteger;


/***/ }),

/***/ "SyAd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MEDIA_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MEDIA_TYPES_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ORDERED_MEDIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ORDERED_MEDIAS_LAUNCHER; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");


var _ICONS, _MEDIA_TYPES_NAMES;


var MEDIA_TYPES = {
  PHOTOS: 'photos',
  VIDEOS: 'videos',
  VIDEOS360: 'videos360',
  STREETVIEWS: 'streetViews',
  FLOORPLAN: 'floorPlans'
};
var ORDERED_MEDIAS = [MEDIA_TYPES.PHOTOS, MEDIA_TYPES.VIDEOS, MEDIA_TYPES.VIDEOS360, MEDIA_TYPES.FLOORPLAN, MEDIA_TYPES.STREETVIEWS];
var ORDERED_MEDIAS_LAUNCHER = [MEDIA_TYPES.VIDEOS360, MEDIA_TYPES.VIDEOS, MEDIA_TYPES.PHOTOS];
var ICONS = (_ICONS = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ICONS, MEDIA_TYPES.PHOTOS, _icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].MEDIA_PICTURE), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ICONS, MEDIA_TYPES.VIDEOS, _icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].MEDIA_VIDEO), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ICONS, MEDIA_TYPES.VIDEOS360, _icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].MEDIA_360_VIDEO), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ICONS, MEDIA_TYPES.STREETVIEWS, _icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].STREET_VIEWS_360), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ICONS, MEDIA_TYPES.FLOORPLAN, _icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].FLOOR_PLAN), _ICONS);
var MEDIA_TYPES_NAMES = (_MEDIA_TYPES_NAMES = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MEDIA_TYPES_NAMES, MEDIA_TYPES.FLOORPLAN, 'media_room_plan'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MEDIA_TYPES_NAMES, MEDIA_TYPES.PHOTOS, 'media_photos'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MEDIA_TYPES_NAMES, MEDIA_TYPES.STREETVIEWS, 'media_streetviews'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MEDIA_TYPES_NAMES, MEDIA_TYPES.VIDEOS, 'media_videos'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_MEDIA_TYPES_NAMES, MEDIA_TYPES.VIDEOS360, 'media_360_view'), _MEDIA_TYPES_NAMES);


/***/ }),

/***/ "UlIv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GOOGLE_API_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GOOGLE_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GOOGLE_API_STREET_VIEW_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GOOGLE_API_JS_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GOOGLE_API_STATIC_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GOOGLE_PLACE_URL; });
var GOOGLE_API_DOMAIN = 'googlemap.api.domain';
var GOOGLE_API_KEY = 'googlemap.api.key';
var GOOGLE_API_STREET_VIEW_PATH = 'googlemap.api.streetViewPath';
var GOOGLE_API_JS_PATH = 'googlemap.api.jsPath';
var GOOGLE_API_STATIC_PATH = 'googlemap.api.staticPath';
var GOOGLE_PLACE_URL = 'http://www.google.com/maps/place';


/***/ }),

/***/ "akds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Video; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("pKEY");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazyload__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("u/u4");
/* harmony import */ var _image_placeholder_ImagePlaceholder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("D0nZ");
/* harmony import */ var _Video_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("JhHq");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






function Video(props) {
  var className = props.className,
      iFrameClassName = props.iFrameClassName,
      _props$ratioKey = props.ratioKey,
      ratioKey = _props$ratioKey === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__[/* default */ "c"].L : _props$ratioKey,
      url = props.url;

  if (!Object(_Video_utils__WEBPACK_IMPORTED_MODULE_5__[/* isVideoUrl */ "b"])(url)) {
    return null;
  }

  return __jsx(_image_placeholder_ImagePlaceholder__WEBPACK_IMPORTED_MODULE_4__[/* ImagePlaceholder */ "a"], {
    aspectRatio: 100 * _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__[/* default */ "c"].VALUES[ratioKey],
    className: className
  }, __jsx(react_lazyload__WEBPACK_IMPORTED_MODULE_2___default.a, {
    className: "bg-no-repeat bg-center bg-cover leading-0 flex h-full items-center justify-center overflow-hidden rounded-12",
    once: true,
    offset: 100
  }, __jsx("iframe", {
    loading: "lazy",
    title: "Video iframe",
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])(iFrameClassName, 'border-0 animate-fadeIn animation-duration-500 h-[54vw] w-[96vw] max-h-full lazy'),
    src: Object(_Video_utils__WEBPACK_IMPORTED_MODULE_5__[/* getVideoUrl */ "a"])(url),
    allowFullScreen: true
  })));
}

/***/ }),

/***/ "cdI6":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("YpBQ");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */
function flattenDeep(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, INFINITY) : [];
}

module.exports = flattenDeep;


/***/ }),

/***/ "h3D+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Multimedia; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/flattenDeep.js
var flattenDeep = __webpack_require__("cdI6");
var flattenDeep_default = /*#__PURE__*/__webpack_require__.n(flattenDeep);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/utils/medias/medias.js
var medias_medias = __webpack_require__("SyAd");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// CONCATENATED MODULE: ./src/client/components/frameworks/action-buttons-group/ActionButtonsGroup.themes.js

var ActionButtonsGroup_themes_themes = function themes(_ref) {
  var isExclusiveCollection = _ref.isExclusiveCollection,
      isScrollable = _ref.isScrollable,
      reverseLabelAndNumber = _ref.reverseLabelAndNumber;
  return {
    "default": {
      thRoot: 'flex flex-wrap -m-1',
      thButton: 'cursor-pointer bg-saffron hocus:bg-saffron capitalize flex flex-1 font-bold gap-10 items-center justify-center m-1 p-10 text-14 text-black transition-bg-color duration-250 ease-in w-full',
      thButtonActive: 'cursor-default bg-saffron hocus:bg-saffron capitalize flex flex-1 font-bold gap-10 items-center justify-center m-1 pointer-events-none p-10 text-14 text-black transition-bg-color duration-250 ease-in w-full',
      thIcon: '',
      thIconLgSize: '3.25rem',
      thIconSize: '1.625rem',
      thText: 'text-initial',
      thNumber: 'block leading-1'
    },
    overlay: {
      thRoot: Object(classnames_utils["a" /* classnames */])('flex gap-10', {
        'mt-auto flex-wrap justify-center': !isScrollable,
        'mt-auto overflow-x-scroll sm:overflow-hidden': isScrollable
      }),
      thButton: 'bg-white hocus:bg-white-active capitalize cursor-pointer flex font-bold gap-5 items-center justify-center px-20 py-10 rounded-pill text-12 text-black hocus:text-black-active duration-250 ease-in transition-all',
      thButtonActive: 'cursor-default bg-black/60 capitalize flex font-bold gap-5 items-center justify-center px-20 py-10 pointer-events-none rounded-pill text-12 text-white duration-250 ease-in transition-all',
      thIcon: 'shrink-0 overflow-visible',
      thIconLgSize: '3rem',
      thIconSize: '1.5rem',
      thText: "flex ".concat(reverseLabelAndNumber ? 'flex-row-reverse ' : '', " font-bold justify-between w-full text-initial"),
      thNumber: 'ps-5'
    },
    overlayCompact: {
      thRoot: Object(classnames_utils["a" /* classnames */])('lg:hidden', {
        'mt-auto flex flex-wrap justify-center rounded-12 bg-white p-5 text-black transition-all hocus:bg-white-active hocus:text-black-active': !isScrollable,
        'mt-auto flex overflow-x-scroll rounded-12 bg-white p-5 text-black transition-all hocus:bg-white-active hocus:text-black-active sm:overflow-hidden': isScrollable
      }),
      thButton: 'text-inherit leading-none mx-5',
      thButtonActive: 'text-inherit leading-none',
      thIcon: 'shrink-0 overflow-visible align-middle',
      thIconLgSize: '3rem',
      thIconSize: '1rem',
      thText: '',
      thHideLabel: true,
      thOverrideMinWidth: true,
      thNumber: ''
    },
    accommodation: {
      thRoot: "divide-y md:divide-x flex flex-col md:flex-row h-full justify-center overflow-hidden border-1 border-t-0 border-".concat(isExclusiveCollection ? 'ultramarine' : 'lightGrey', " rounded-b-12 w-full"),
      thButton: 'flex gap-5 w-full items-center justify-center grow cursor-pointer bg-white capitalize font-bold p-10 text-14',
      thButtonActive: 'flex gap-5 w-full items-center justify-center grow cursor-pointer bg-white capitalize font-bold p-10 text-14',
      thIcon: "overflow-visible text-".concat(isExclusiveCollection ? 'ultramarine' : 'black'),
      thIconLgSize: '4rem',
      thIconSize: '2rem',
      thText: 'font-bold text-initial text-black duration-250 ease-in transition-all',
      thNumber: 'ps-5'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/action-buttons-group/ActionButtonsGroup.jsx


var __jsx = react_default.a.createElement;





var ActionButtonsGroup_ActionButtonsGroup = function ActionButtonsGroup(_ref) {
  var className = _ref.className,
      isExclusiveCollection = _ref.isExclusiveCollection,
      isScrollable = _ref.isScrollable,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$minWidth = _ref.minWidth,
      minWidthProp = _ref$minWidth === void 0 ? 'initial' : _ref$minWidth,
      _ref$reverseLabelAndN = _ref.reverseLabelAndNumber,
      reverseLabelAndNumber = _ref$reverseLabelAndN === void 0 ? true : _ref$reverseLabelAndN,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var track = Object(useTracking["a" /* useTracking */])();

  if (!items.length) {
    return null;
  }

  var _themes$theme = ActionButtonsGroup_themes_themes({
    isExclusiveCollection: isExclusiveCollection,
    isScrollable: isScrollable,
    reverseLabelAndNumber: reverseLabelAndNumber
  })[theme],
      thRoot = _themes$theme.thRoot,
      thButton = _themes$theme.thButton,
      thButtonActive = _themes$theme.thButtonActive,
      thIcon = _themes$theme.thIcon,
      thIconLgSize = _themes$theme.thIconLgSize,
      thIconSize = _themes$theme.thIconSize,
      thText = _themes$theme.thText,
      thHideLabel = _themes$theme.thHideLabel,
      thOverrideMinWidth = _themes$theme.thOverrideMinWidth,
      thNumber = _themes$theme.thNumber;
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, items.map(function (_ref2) {
    var ariaLabel = _ref2.ariaLabel,
        buttonClassName = _ref2.buttonClassName,
        dataTestId = _ref2.dataTestId,
        iconIsNotSquare = _ref2.iconIsNotSquare,
        iconName = _ref2.iconName,
        id = _ref2.id,
        isActive = _ref2.isActive,
        label = _ref2.label,
        minWidth = _ref2.minWidth,
        number = _ref2.number,
        _onClick = _ref2.onClick,
        trackingData = _ref2.trackingData;
    return __jsx("button", {
      "aria-disabled": isActive,
      "aria-label": ariaLabel,
      className: Object(classnames_utils["a" /* classnames */])(buttonClassName, Object(defineProperty["a" /* default */])({}, thButtonActive, isActive), Object(defineProperty["a" /* default */])({}, thButton, !isActive)),
      "data-testid": dataTestId,
      key: "ActionButtonsGroup-".concat(id),
      onClick: function onClick() {
        _onClick === null || _onClick === void 0 ? void 0 : _onClick();
        trackingData && track(trackingData);
      },
      style: {
        minWidth: thOverrideMinWidth ? 'initial' : minWidth || minWidthProp
      },
      type: "button"
    }, iconName && __jsx(Icon["a" /* Icon */], {
      className: thIcon,
      isNotSquare: iconIsNotSquare,
      name: iconName,
      width: iconIsNotSquare ? thIconLgSize : thIconSize
    }), label && !thHideLabel && __jsx("span", {
      className: thText
    }, number && __jsx("span", {
      className: thNumber
    }, "".concat(number, " ")), label));
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/zoom/Zoom.jsx
var Zoom = __webpack_require__("7x6O");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.jsx + 1 modules
var ProgressBar = __webpack_require__("woxT");

// EXTERNAL MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx + 2 modules
var SliderHandler = __webpack_require__("A5Hi");

// CONCATENATED MODULE: ./src/client/components/frameworks/carousel/Carousel.jsx

var Carousel_jsx = react_default.a.createElement;






var Carousel_Carousel = function Carousel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      hasInfiniteScroll = _ref.hasInfiniteScroll,
      _ref$initialIndex = _ref.initialIndex,
      initialIndex = _ref$initialIndex === void 0 ? 0 : _ref$initialIndex,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel;
  var childrenCount = react["Children"].toArray(children).filter(Boolean).length;

  if (!childrenCount) {
    return null;
  }

  return Carousel_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative isolate overflow-hidden', className)
  }, Carousel_jsx(SliderHandler["a" /* SliderHandler */], {
    className: "h-full w-full",
    hasInfiniteScroll: hasInfiniteScroll,
    hasKeyboardSupport: true,
    hasSwipeSupport: true,
    initialIndex: initialIndex,
    items: children
  }, function (_ref2) {
    var hasControls = _ref2.hasControls,
        index = _ref2.index,
        isNextControlDisabled = _ref2.isNextControlDisabled,
        isPreviousControlDisabled = _ref2.isPreviousControlDisabled,
        itemsNode = _ref2.itemsNode,
        onNext = _ref2.onNext,
        onPrevious = _ref2.onPrevious;
    return Carousel_jsx("div", {
      className: "relative isolate flex w-full flex-1 pb-20"
    }, itemsNode, hasControls && Carousel_jsx("div", {
      className: "fap-10 pointer-events-none absolute inset-0 m-auto flex w-full items-center justify-between px-20"
    }, !isPreviousControlDisabled && Carousel_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "pointer-events-auto z-1 me-auto shadow-sm",
      color: colors["a" /* COLORS */].WHITE,
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && Carousel_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "pointer-events-auto z-1 ms-auto shadow-sm",
      color: colors["a" /* COLORS */].WHITE,
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })), hasControls && Carousel_jsx("div", {
      className: "absolute bottom-0 left-0 w-full"
    }, Carousel_jsx(ProgressBar["a" /* ProgressBar */], {
      color: colors["a" /* COLORS */].WHITE,
      max: childrenCount,
      min: 1,
      value: index + 1
    })));
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.jsx
var Video = __webpack_require__("akds");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("iKE+");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/axios/index.js
var axios = __webpack_require__("ggb3");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/errors/errors.js + 4 modules
var errors = __webpack_require__("wNDy");

// CONCATENATED MODULE: ./src/client/components/utils/youku-api/index.js






function getVideoThumbnailUrl(videoId) {
  var clientId = config_default.a.get('youku.clientId');

  if (!clientId) {
    return Promise.reject(new errors["b" /* BadRequest */]('Missing Youku client Id'));
  }

  if (!videoId) {
    return Promise.reject(new errors["b" /* BadRequest */]('Missing Youku video Id'));
  }

  return axios_default.a.get("https://api.youku.com/videos/show.json?client_id=".concat(clientId, "&video_id=").concat(videoId)).then(function (response) {
    return response.data.bigThumbnail || response.data.thumbnail || new errors["d" /* NotFoundError */]('Youku video not found');
  })["catch"](function () {
    return null;
  });
}
// CONCATENATED MODULE: ./src/client/components/frameworks/image/YoukuThumbnail.jsx











var YoukuThumbnail_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var YoukuThumbnail_YoukuThumbnail = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(YoukuThumbnail, _Component);

  var _super = _createSuper(YoukuThumbnail);

  function YoukuThumbnail(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, YoukuThumbnail);

    _this = _super.call(this, props);
    _this.state = {
      thumbnailUrl: null
    };
    return _this;
  }

  Object(createClass["a" /* default */])(YoukuThumbnail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var youkuRegEx = new RegExp('https://vthumb.ykimg.com/([a-zA-Z0-9]+)');
      var urlMatch = youkuRegEx.exec(this.props.imageUrl);

      if (urlMatch && urlMatch[1]) {
        getVideoThumbnailUrl(urlMatch[1]).then(function (youkuThumbnail) {
          _this2.setState({
            thumbnailUrl: youkuThumbnail
          });
        }).catch(function () {
          return null;
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var thumbnailUrl = this.state.thumbnailUrl;
      return YoukuThumbnail_jsx(Image["b" /* default */], Object(esm_extends["a" /* default */])({}, this.props, {
        imageUrl: thumbnailUrl
      }));
    }
  }]);

  return YoukuThumbnail;
}(react["Component"]);
// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// CONCATENATED MODULE: ./src/client/components/frameworks/media-thumbnail/MediaThumbnail.jsx

var MediaThumbnail_jsx = react_default.a.createElement;






var MediaThumbnail_MediaThumbnail = function MediaThumbnail(_ref) {
  var alt = _ref.alt,
      children = _ref.children,
      className = _ref.className,
      hasLazyLoading = _ref.hasLazyLoading,
      iconName = _ref.iconName,
      _onClick = _ref.onClick,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? ratios_utils["c" /* default */].M : _ref$ratio,
      src = _ref.src,
      trackingData = _ref.trackingData,
      ratioDisplay = _ref.ratioDisplay;
  var hasChildren = !!react["Children"].count(children);
  var track = Object(useTracking["a" /* useTracking */])(trackingData);

  if (!hasChildren && isEmpty_default()(src)) {
    return null;
  }

  return MediaThumbnail_jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])('relative block h-full w-full overflow-hidden bg-white transition-opacity duration-250 ease-in hover:opacity-75', className),
    onClick: function onClick() {
      _onClick === null || _onClick === void 0 ? void 0 : _onClick();
      trackingData && track();
    },
    type: "button"
  }, hasChildren ? children : MediaThumbnail_jsx(Image["b" /* default */], {
    altMsg: alt,
    hasLazyLoading: hasLazyLoading,
    imageUrl: src,
    ratioKey: ratio,
    ratioDisplay: ratioDisplay
  }), !!iconName && MediaThumbnail_jsx("div", {
    className: "absolute end-0 top-0 m-5 size-50 bg-black/60 p-10 leading-0 text-white"
  }, MediaThumbnail_jsx(Icon["a" /* Icon */], {
    name: iconName,
    width: "100%"
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/multimedia-launcher/MultimediaLauncher.jsx





var MultimediaLauncher_jsx = react_default.a.createElement;









var YOUKU_SRC = 'vthumb.ykimg.com';

function MultimediaLauncherThumbnail(props) {
  return props.src ? MultimediaLauncher_jsx(MediaThumbnail_MediaThumbnail, Object(esm_extends["a" /* default */])({}, props, {
    hasLazyLoading: props.hasLazyLoading
  }), props.src.includes(YOUKU_SRC) ? MultimediaLauncher_jsx(YoukuThumbnail_YoukuThumbnail, {
    imageUrl: props.src,
    ratioKey: props.ratio
  }) : null) : null;
}

function MultimediaLauncher(_ref) {
  var buttons = _ref.buttons,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      galleryLabel = _ref.galleryLabel,
      hasLazyLoading = _ref.hasLazyLoading,
      isExclusiveCollection = _ref.isExclusiveCollection,
      isImageSlideShow = _ref.isImageSlideShow,
      isOverlay = _ref.isOverlay,
      _ref$medias = _ref.medias,
      medias = _ref$medias === void 0 ? [] : _ref$medias,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel,
      theme = _ref.theme;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var defaultTheme = isOverlay ? 'overlay' : 'default';
  var computedTheme = theme || defaultTheme;
  return MultimediaLauncher_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('w-full overflow-hidden', {
      'rounded-12': computedTheme === 'default'
    }, className)
  }, !isOverlay && !isImageSlideShow && (isTablet ? MultimediaLauncher_jsx("div", {
    className: "animation-duration-500 -m-1 flex animate-fadeIn border-b-1 border-transparent"
  }, MultimediaLauncher_jsx("div", {
    className: "w-1/2 p-1"
  }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, medias[0], {
    hasLazyLoading: hasLazyLoading,
    ratioDisplay: 1 / 2
  }))), MultimediaLauncher_jsx("div", {
    className: "flex w-1/2 flex-wrap"
  }, medias.slice(1, 5).map(function (media) {
    return MultimediaLauncher_jsx("div", {
      className: "w-1/2 p-1",
      key: "MultimediaLauncherThumbnail-".concat(media.src)
    }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, media, {
      hasLazyLoading: hasLazyLoading,
      ratioDisplay: 1 / 4
    })));
  }))) : MultimediaLauncher_jsx("div", {
    className: "animation-duration-500 animate-fadeIn border-b-2 border-transparent"
  }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, medias[0], {
    hasLazyLoading: hasLazyLoading
  })))), !isOverlay && isImageSlideShow && MultimediaLauncher_jsx("div", {
    className: "animation-duration-500 animate-fadeIn"
  }, medias.length > 0 ? MultimediaLauncher_jsx(ImageSlideShow["a" /* ImageSlideShow */], {
    className: className,
    closeLabel: closeLabel,
    galleryLabel: galleryLabel,
    hasInfiniteScroll: true,
    hasLazyLoading: false,
    media: medias.map(function (_ref2) {
      var alt = _ref2.alt,
          onClick = _ref2.onClick,
          src = _ref2.src;
      return {
        alt: alt,
        onClick: onClick,
        src: src
      };
    }),
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: ratios_utils["c" /* default */].XL
  }) : MultimediaLauncher_jsx(Image["b" /* default */], {
    altMsg: medias[0].alt,
    hasLazyLoading: false,
    imageUrl: medias[0].src,
    ratioKey: ratios_utils["c" /* default */].XL
  })), MultimediaLauncher_jsx(ActionButtonsGroup_ActionButtonsGroup, {
    className: "animation-duration-500 animate-fadeIn",
    isExclusiveCollection: isExclusiveCollection,
    items: buttons,
    minWidth: isOverlay ? '6.25rem' : '8.4375rem',
    theme: computedTheme
  }));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/map/StreetView.jsx
var StreetView = __webpack_require__("HKmi");

// CONCATENATED MODULE: ./src/client/components/widgets/multimedia/Multimedia.jsx


























var Multimedia_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Multimedia_createSuper(Derived) { var hasNativeReflectConstruct = Multimedia_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Multimedia_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }















var DIMENSIONS = {
  w: 'auto',
  h: 'auto'
};

var Multimedia_Multimedia = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(_Multimedia, _Component);

  var _super = Multimedia_createSuper(_Multimedia);

  function _Multimedia(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, _Multimedia);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "closeCarousel", function () {
      _this.setState({
        activeMedias: '',
        carouselIndex:  false || _this.props.initialIndex
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "showCarousel", function (type) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      _this.setState({
        activeMedias: type,
        carouselIndex: index
      });
    });

    _this.state = {
      activeMedias: '',
      carouselIndex: 0
    };
    return _this;
  }

  Object(createClass["a" /* default */])(_Multimedia, [{
    key: "getCarouselItem",

    /* Carousel */
    // eslint-disable-next-line max-params, class-methods-use-this, clubmed/no-fake-component
    value: function getCarouselItem(type, _ref, altMsg, isDesktop) {
      var fov = _ref.fov,
          heading = _ref.heading,
          latitude = _ref.latitude,
          longitude = _ref.longitude,
          url = _ref.url;

      switch (type) {
        case medias_medias["b" /* MEDIA_TYPES */].PHOTOS:
          return Multimedia_jsx("div", {
            "data-testid": "MultimediaPhoto",
            className: "relative flex h-full w-full max-w-full flex-1 items-center justify-center overflow-hidden"
          }, Multimedia_jsx(Image["a" /* Image */], {
            altMsg: altMsg,
            classNameImg: "absolute top-1/2 left-1/2 max-w-[2000px] transform -translate-x-1/2 -translate-y-1/2",
            hasLazyLoading: false,
            key: "CarouselItem-".concat(type, "-").concat(url),
            imageUrl: url,
            dimensions: DIMENSIONS,
            fullscreen: true,
            transformation: "resize"
          }));

        case medias_medias["b" /* MEDIA_TYPES */].STREETVIEWS:
          if (url === null || url === void 0 ? void 0 : url.includes('matterport')) {
            return Multimedia_jsx("iframe", {
              title: "matterport iframe",
              width: "100%",
              height: "100%",
              src: "".concat(url, "&play=1"),
              frameBorder: "0",
              id: "matterport-iframe"
            });
          }

          return Multimedia_jsx(StreetView["a" /* StreetView */], {
            fov: fov,
            heading: heading,
            key: "CarouselItem-".concat(type, "-").concat(latitude, "-").concat(longitude),
            latitude: latitude,
            longitude: longitude
          });

        case medias_medias["b" /* MEDIA_TYPES */].FLOORPLAN:
          return isDesktop ? Multimedia_jsx("div", {
            className: "h-full pt-20"
          }, Multimedia_jsx("div", {
            "data-testid": "MultimediaFloorplan",
            className: "relative flex h-full w-full max-w-full flex-1 items-center justify-center overflow-hidden"
          }, Multimedia_jsx(Image["a" /* Image */], {
            altMsg: altMsg,
            classNameImg: "absolute top-1/2 left-1/2 max-w-[2000px] transform -translate-x-1/2 -translate-y-1/2",
            hasLazyLoading: false,
            key: "CarouselItem-".concat(type, "-").concat(url),
            imageUrl: url,
            dimensions: DIMENSIONS,
            fullscreen: true,
            transformation: "resize"
          }))) : Multimedia_jsx("div", {
            className: "flex h-full max-w-screen flex-col justify-center"
          }, Multimedia_jsx(Zoom["a" /* Zoom */], {
            imageUrl: url,
            altMsg: "Floor plan",
            inert: true
          }));

        case medias_medias["b" /* MEDIA_TYPES */].VIDEOS:
        case medias_medias["b" /* MEDIA_TYPES */].VIDEOS360:
          return Multimedia_jsx(Video["a" /* Video */], {
            className: "static m-auto flex h-full flex-1 items-center justify-center overflow-hidden md:w-4/5 md:max-w-4/5",
            key: "CarouselItem-".concat(type, "-").concat(url),
            url: url
          });

        default:
          return null;
      }
    }
  }, {
    key: "getCarouselItems",
    value: function getCarouselItems(type, isDesktop) {
      var _this2 = this;

      var _this$props = this.props,
          medias = _this$props.medias,
          _this$props$pictureAl = _this$props.pictureAltLabel,
          pictureAltLabel = _this$props$pictureAl === void 0 ? '' : _this$props$pictureAl;
      return (medias[type] || []).map(function (media, idx) {
        var altMsg = (media === null || media === void 0 ? void 0 : media.alt) || Object(dist["messageFormat"])(pictureAltLabel).format({
          nb: idx + 1,
          total: medias[type].length
        });

        var carouselItem = _this2.getCarouselItem(type, media, altMsg, isDesktop);

        return Multimedia_jsx(react["Fragment"], {
          key: "CarouselItemWrapper-".concat(type, "-").concat(media.url)
        }, carouselItem);
      });
    }
    /* Medias */

  }, {
    key: "hasMedias",
    value: function hasMedias(isDesktop) {
      var _this3 = this;

      return Object.keys(this.props.medias).reduce(function (has, type) {
        return has || _this3.hasTypeMedias(type, isDesktop);
      }, false);
    }
  }, {
    key: "hasTypeMedias",
    value: function hasTypeMedias(type, isDesktop) {
      var hasTypeMedias = Array.isArray(get_default()(this.props, ['medias', type])) && get_default()(this.props, ['medias', type]).length > 0;

      if (type === medias_medias["b" /* MEDIA_TYPES */].VIDEOS360) {
        return hasTypeMedias && isDesktop;
      }

      return hasTypeMedias;
    }
  }, {
    key: "mapLauncherMedias",
    value: function mapLauncherMedias(type, isDesktop) {
      var _this4 = this;

      var medias = this.hasTypeMedias(type, isDesktop) ? this.props.medias[type] : [];
      return medias.map(function (media, index) {
        return {
          alt: Object(dist["messageFormat"])(_this4.props.launcherPictureAltLabel || '').format({
            nb: index + 1,
            mediaType: _this4.props.labels && _this4.props.labels[type]
          }),
          hasForcedImage: !!media.thumbnailUrl,
          iconName: type === medias_medias["b" /* MEDIA_TYPES */].PHOTOS ? '' : medias_medias["a" /* ICONS */][type],
          onClick: function onClick() {
            var _this4$props, _this4$props$onClickM;

            (_this4$props = _this4.props) === null || _this4$props === void 0 ? void 0 : (_this4$props$onClickM = _this4$props.onClickMediaBtn) === null || _this4$props$onClickM === void 0 ? void 0 : _this4$props$onClickM.call(_this4$props, type);

            _this4.showCarousel(type, index);
          },
          ratio: _this4.props.ratioKey,
          src: media.thumbnailUrl || media.url || media.imageLarge || ''
        };
      });
    }
  }, {
    key: "getLauncherMedias",
    value: function getLauncherMedias(isDesktop, hasImageSlideShowLauncher) {
      var _this5 = this;

      var types = hasImageSlideShowLauncher ? [medias_medias["b" /* MEDIA_TYPES */].PHOTOS] : medias_medias["e" /* ORDERED_MEDIAS_LAUNCHER */];
      return flattenDeep_default()(types.map(function (type) {
        return _this5.mapLauncherMedias(type, isDesktop);
      })).filter(function (i) {
        return !!i.src;
      });
    }
  }, {
    key: "getLauncherProps",
    value: function getLauncherProps(isDesktop) {
      var _this6 = this;

      var _this$props2 = this.props,
          _this$props2$hasImage = _this$props2.hasImageSlideShowLauncher,
          hasImageSlideShowLauncher = _this$props2$hasImage === void 0 ? false : _this$props2$hasImage,
          _this$props2$hasFullS = _this$props2.hasFullScreenButton,
          hasFullScreenButton = _this$props2$hasFullS === void 0 ? false : _this$props2$hasFullS,
          _this$props2$labels = _this$props2.labels,
          labels = _this$props2$labels === void 0 ? {} : _this$props2$labels,
          _this$props2$medias = _this$props2.medias,
          medias = _this$props2$medias === void 0 ? {} : _this$props2$medias,
          openGalleryLabel = _this$props2.openGalleryLabel,
          initialIndex = _this$props2.initialIndex;
      var hasPhotosTypeMedias = this.hasTypeMedias(medias_medias["b" /* MEDIA_TYPES */].PHOTOS, isDesktop);

      var getIndexToOpenTo = function getIndexToOpenTo(type, index) {
        if (type !== medias_medias["b" /* MEDIA_TYPES */].PHOTOS) {
          return index;
        }

        return initialIndex || index;
      };

      var getButton = function getButton(type, index) {
        var numberOfItems = Array.isArray(medias === null || medias === void 0 ? void 0 : medias[type]) && type !== medias_medias["b" /* MEDIA_TYPES */].FLOORPLAN ? medias[type].length : null;
        return {
          ariaLabel: openGalleryLabel ? "".concat(labels[type], " (").concat(get_default()(medias, [type], []).length, ") - ").concat(openGalleryLabel) : null,
          dataTestId: "Multimedia-".concat(type, "-button"),
          iconIsNotSquare: type === medias_medias["b" /* MEDIA_TYPES */].STREETVIEWS,
          iconName: medias_medias["a" /* ICONS */][type],
          id: type,
          isActive: type === _this6.state.activeMedias,
          label: labels[type],
          number: numberOfItems,
          onClick: function onClick() {
            var _this6$props, _this6$props$onClickM;

            (_this6$props = _this6.props) === null || _this6$props === void 0 ? void 0 : (_this6$props$onClickM = _this6$props.onClickMediaBtn) === null || _this6$props$onClickM === void 0 ? void 0 : _this6$props$onClickM.call(_this6$props, type);

            _this6.showCarousel(type, getIndexToOpenTo(type, index));
          }
        };
      };

      var buttons = medias_medias["d" /* ORDERED_MEDIAS */].map(function (type, index) {
        var internalIndex = type === medias_medias["b" /* MEDIA_TYPES */].PHOTOS ? index : 0;
        return _this6.hasTypeMedias(type, isDesktop) ? getButton(type, internalIndex) : null;
      }).filter(Boolean);
      var extraButtons = [hasFullScreenButton ? _objectSpread(_objectSpread({}, getButton(medias_medias["b" /* MEDIA_TYPES */].PHOTOS)), {}, {
        iconName: icons["a" /* ICONS */].EXPAND,
        label: '',
        minWidth: 'initial',
        buttonClassName: 'absolute end-0 md:bottom-0 md:top-auto top-0 mt-10 md:mx-10 md:mx-20 mb-0'
      }) : null].filter(Boolean);
      return {
        buttons: buttons,
        extraButtons: extraButtons,
        medias: hasImageSlideShowLauncher && hasPhotosTypeMedias ? this.getLauncherMedias(isDesktop, hasImageSlideShowLauncher) // $FlowFixMe
        : this.getLauncherMedias(isDesktop).slice(0, 5)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      return Multimedia_jsx(ResponsiveContext["a" /* ResponsiveContext */].Consumer, null, function (_ref2) {
        var isDesktop = _ref2.isDesktop;

        if (!_this7.hasMedias(isDesktop)) {
          return null;
        }

        var _this7$state = _this7.state,
            activeMedias = _this7$state.activeMedias,
            carouselIndex = _this7$state.carouselIndex;
        var _this7$props = _this7.props,
            className = _this7$props.className,
            closeLabel = _this7$props.closeLabel,
            descriptionLabels = _this7$props.descriptionLabels,
            galleryLabel = _this7$props.galleryLabel,
            hasImageSlideShowLauncher = _this7$props.hasImageSlideShowLauncher,
            isExclusiveCollection = _this7$props.isExclusiveCollection,
            isOverlay = _this7$props.isOverlay,
            nextLabel = _this7$props.nextLabel,
            portalName = _this7$props.portalName,
            previousLabel = _this7$props.previousLabel,
            theme = _this7$props.theme; // $FlowFixMe

        var descriptionLabel = descriptionLabels === null || descriptionLabels === void 0 ? void 0 : descriptionLabels[activeMedias];

        var items = _this7.getCarouselItems(activeMedias, isDesktop);

        var launcherProps = _this7.getLauncherProps(isDesktop);

        return Multimedia_jsx(react["Fragment"], null, Multimedia_jsx(MultimediaLauncher, {
          buttons: [].concat(Object(toConsumableArray["a" /* default */])(launcherProps.buttons), Object(toConsumableArray["a" /* default */])(launcherProps.extraButtons)),
          className: className,
          closeLabel: closeLabel,
          galleryLabel: galleryLabel,
          isExclusiveCollection: isExclusiveCollection,
          hasLazyLoading: true,
          isImageSlideShow: hasImageSlideShowLauncher,
          isOverlay: isOverlay,
          medias: launcherProps.medias,
          nextLabel: nextLabel,
          previousLabel: previousLabel,
          theme: theme
        }), !!activeMedias && Multimedia_jsx(Backdrop["a" /* Backdrop */], {
          ariaLabel: galleryLabel,
          className: "backdrop-blur-[4px] backdrop-saturate-0",
          closeLabel: closeLabel,
          hasCloseButton: true,
          onClose: _this7.closeCarousel,
          portalName: portalName
        }, Multimedia_jsx("div", {
          className: "flex h-full w-full flex-col"
        }, Multimedia_jsx(Carousel_Carousel, {
          className: "flex flex-1",
          hasInfiniteScroll: true,
          initialIndex: carouselIndex,
          key: Math.random(),
          nextLabel: nextLabel,
          previousLabel: previousLabel
        }, items), descriptionLabel && Multimedia_jsx("div", {
          className: "flex w-full justify-center p-20 py-10"
        }, Multimedia_jsx("span", {
          className: "text-center text-12 text-white"
        }, descriptionLabel)), Multimedia_jsx("div", {
          className: "flex h-[72px] items-center justify-center px-10"
        }, Multimedia_jsx(ActionButtonsGroup_ActionButtonsGroup, {
          isScrollable: true,
          items: launcherProps.buttons,
          minWidth: "6.25rem",
          reverseLabelAndNumber: theme !== 'accommodation',
          theme: "overlay"
        })))));
      });
    }
  }]);

  return _Multimedia;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Multimedia_Multimedia, "defaultProps", {
  medias: {},
  ratioKey: ratios_utils["c" /* default */].L
});

var Multimedia = Multimedia_Multimedia;

/***/ }),

/***/ "r+bv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ImmersiveSlideShow_ImmersiveSlideShow; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/item/ImmersiveSlideShowItem.jsx
var __jsx = react_default.a.createElement;



var ImmersiveSlideShowItem_ImmersiveSlideShowItem = function ImmersiveSlideShowItem(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      _ref$immersiveSize = _ref.immersiveSize,
      immersiveSize = _ref$immersiveSize === void 0 ? 'large' : _ref$immersiveSize,
      _ref$isImmersive = _ref.isImmersive,
      isImmersive = _ref$isImmersive === void 0 ? false : _ref$isImmersive,
      src = _ref.src;
  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative', className),
    key: src
  }, __jsx(Hero["a" /* Hero */], {
    alt: alt,
    isImmersive: isImmersive,
    size: immersiveSize,
    url: src
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/heroUtils.js
var heroUtils = __webpack_require__("5xkM");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/controls/ImmersiveSlideShowControls.themes.js

var themes = {
  "default": {
    thRoot: 'absolute flex items-center gap-10 justify-between max-w-site px-20 lg:px-0 m-auto inset-0 pointer-events-none w-full',
    thButtonColor: colors["a" /* COLORS */].WHITE,
    thPreviousButton: 'me-auto pointer-events-auto shadow-sm z-1',
    thNextButton: 'ms-auto pointer-events-auto shadow-sm z-1',
    thPageIndicator: 'absolute left-0 bottom-0 mb-30 ml-30 inline-flex items-center overflow-hidden px-10 py-5 font-sans bg-white rounded-pill text-12'
  },
  activities: {
    thRoot: 'absolute bottom-0 flex gap-5 items-center justify-end p-20 pointer-events-none right-0 w-full z-1',
    thButtonColor: colors["a" /* COLORS */].WHITE,
    thPreviousButton: 'pointer-events-auto shadow-sm z-1',
    thNextButton: 'pointer-events-auto shadow-sm z-1',
    thPageIndicator: 'bg-white font-bold font-sans inline-flex items-end me-auto overflow-hidden px-20 py-10 rounded-pill text-14'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/controls/ImmersiveSlideShowControls.jsx
var ImmersiveSlideShowControls_jsx = react_default.a.createElement;




var ImmersiveSlideShowControls_ImmersiveSlideShowControls = function ImmersiveSlideShowControls(_ref) {
  var activeIndex = _ref.activeIndex,
      className = _ref.className,
      isNextDisabled = _ref.isNextDisabled,
      isPrevDisabled = _ref.isPrevDisabled,
      _ref$isPaginationDisa = _ref.isPaginationDisabled,
      isPaginationDisabled = _ref$isPaginationDisa === void 0 ? true : _ref$isPaginationDisa,
      nextLabel = _ref.nextLabel,
      onNext = _ref.onNext,
      onPrev = _ref.onPrev,
      previousLabel = _ref.previousLabel,
      slidesCount = _ref.slidesCount,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = themes[theme],
      thRoot = _themes$theme.thRoot,
      thButtonColor = _themes$theme.thButtonColor,
      thPreviousButton = _themes$theme.thPreviousButton,
      thNextButton = _themes$theme.thNextButton,
      thPageIndicator = _themes$theme.thPageIndicator;
  return ImmersiveSlideShowControls_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, !isPaginationDisabled && ImmersiveSlideShowControls_jsx("div", {
    className: thPageIndicator
  }, activeIndex, " of ", slidesCount), !isPrevDisabled && ImmersiveSlideShowControls_jsx(ArrowButton["a" /* ArrowButton */], {
    className: thPreviousButton,
    color: thButtonColor,
    label: previousLabel,
    onClick: onPrev
  }), !isNextDisabled && ImmersiveSlideShowControls_jsx(ArrowButton["a" /* ArrowButton */], {
    className: thNextButton,
    color: thButtonColor,
    label: nextLabel,
    onClick: onNext,
    rotation: 180
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/large/ImmersiveSlideShowLarge.jsx



var ImmersiveSlideShowLarge_jsx = react_default.a.createElement;





var getInitialDisplayedIndex = function getInitialDisplayedIndex(length) {
  return Array(length).fill(false).map(function (_, idx) {
    return idx === length - 1 || idx < 2;
  });
};

var ImmersiveSlideShowLarge_ImmersiveSlideShowLarge = function ImmersiveSlideShowLarge(_ref) {
  var className = _ref.className,
      _ref$controlsTheme = _ref.controlsTheme,
      controlsTheme = _ref$controlsTheme === void 0 ? 'default' : _ref$controlsTheme,
      _ref$isPaginationDisa = _ref.isPaginationDisabled,
      isPaginationDisabled = _ref$isPaginationDisa === void 0 ? true : _ref$isPaginationDisa,
      _ref$immersiveSize = _ref.immersiveSize,
      immersiveSize = _ref$immersiveSize === void 0 ? 'large' : _ref$immersiveSize,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel;

  var _useState = Object(react["useState"])(0),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var _useState2 = Object(react["useState"])(getInitialDisplayedIndex(items.length)),
      displayedIndex = _useState2[0],
      setDisplayedIndex = _useState2[1];

  Object(react["useEffect"])(function () {
    if (displayedIndex.every(Boolean)) {
      return;
    }

    var newDisplayedIndex = displayedIndex.map(function (isDisplayed, idx) {
      return isDisplayed || idx === activeIndex + 1 || idx === activeIndex - 1;
    });
    setDisplayedIndex(newDisplayedIndex);
  }, [activeIndex]);

  if (!items.length) {
    return null;
  }

  var increase = function increase() {
    activeIndex === items.length - 1 ? setActiveIndex(0) : setActiveIndex(activeIndex + 1);
  };

  var decrease = function decrease() {
    activeIndex === 0 ? setActiveIndex(items.length - 1) : setActiveIndex(activeIndex - 1);
  };

  var _getHeroDimensions = Object(heroUtils["e" /* getHeroDimensions */])(immersiveSize),
      heightClassName = _getHeroDimensions.heightClassName;

  return ImmersiveSlideShowLarge_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(heightClassName, 'overflow-hidden relative', className)
  }, items.map(function (item, idx) {
    return ImmersiveSlideShowLarge_jsx("div", {
      "aria-hidden": idx !== activeIndex,
      className: Object(classnames_utils["a" /* classnames */])('absolute inset-0 duration-500 ease-in transition-opacity', {
        'opacity-100': idx === activeIndex,
        'opacity-0': idx !== activeIndex
      }),
      key: idx,
      tabIndex: -1
    }, displayedIndex[idx] ? item : null);
  }), items.length > 1 && ImmersiveSlideShowLarge_jsx(ImmersiveSlideShowControls_ImmersiveSlideShowControls, {
    nextLabel: nextLabel,
    activeIndex: activeIndex + 1,
    slidesCount: items.length,
    onNext: increase,
    onPrev: decrease,
    previousLabel: previousLabel,
    isPaginationDisabled: isPaginationDisabled,
    theme: controlsTheme
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/debounce.js
var debounce = __webpack_require__("RNvQ");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/narrow/ImmersiveSlideShowNarrow.jsx




var ImmersiveSlideShowNarrow_jsx = react_default.a.createElement;




var PRELOADED_ITEMS_NB = 3;

var ImmersiveSlideShowNarrow_getInitialDisplayedIndex = function getInitialDisplayedIndex(length) {
  return Array(length).fill(false).fill(true, 0, PRELOADED_ITEMS_NB);
};

var ImmersiveSlideShowNarrow_ImmersiveSlideShowNarrow = function ImmersiveSlideShowNarrow(_ref) {
  var className = _ref.className,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel,
      _ref$isPaginationDisa = _ref.isPaginationDisabled,
      isPaginationDisabled = _ref$isPaginationDisa === void 0 ? true : _ref$isPaginationDisa,
      _ref$controlsTheme = _ref.controlsTheme,
      controlsTheme = _ref$controlsTheme === void 0 ? 'default' : _ref$controlsTheme;

  var _useState = Object(react["useState"])(0),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var _useState2 = Object(react["useState"])(ImmersiveSlideShowNarrow_getInitialDisplayedIndex(items.length)),
      displayedIndex = _useState2[0],
      setDisplayedIndex = _useState2[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var coef = isRTL ? -1 : 1;
  var containerRef = Object(react["useRef"])(null);

  var scroll = function scroll(index, e) {
    if (e) {
      e.preventDefault();
    }

    var isFirst = activeIndex === 0;
    var isLast = activeIndex === items.length - 1;

    if (isFirst && index < activeIndex) {
      index = items.length - 1;
    }

    if (isLast && index > activeIndex) {
      index = 0;
    }

    if (containerRef && containerRef.current) {
      containerRef.current.scrollTo({
        behavior: 'smooth',
        left: coef * containerRef.current.scrollWidth * (index / items.length)
      });
    }

    setActiveIndex(index);
  };

  var onScroll = debounce_default()(function () {
    if (containerRef && containerRef.current) {
      var pos = Math.round(coef * containerRef.current.scrollLeft / containerRef.current.scrollWidth * items.length);
      setActiveIndex(pos);
    }
  }, 150);

  Object(react["useEffect"])(function () {
    // $FlowFixMe
    containerRef.current.addEventListener('scroll', onScroll);
    return function () {
      // $FlowFixMe
      containerRef.current.removeEventListener('scroll', onScroll);
    };
  }, [coef]);
  Object(react["useEffect"])(function () {
    if (displayedIndex.every(Boolean)) {
      return;
    }

    var newDisplayedIndex = displayedIndex.map(function (_, idx) {
      return idx < activeIndex + PRELOADED_ITEMS_NB;
    });
    setDisplayedIndex(newDisplayedIndex);
  }, [activeIndex]);

  if (!items.length) {
    return null;
  }

  return ImmersiveSlideShowNarrow_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('overflow-hidden relative', className)
  }, ImmersiveSlideShowNarrow_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex flex-row flex-nowrap overflow-auto snap-x snap-mandatory w-full', className),
    dir: isRTL ? 'rtl' : 'ltr',
    ref: containerRef
  }, items.map(function (item, idx) {
    return ImmersiveSlideShowNarrow_jsx("div", {
      className: "flex-none overflow-visible snap-center w-full",
      key: idx,
      tabIndex: -1
    }, displayedIndex[idx] ? item : null);
  })), items.length > 1 && ImmersiveSlideShowNarrow_jsx(ImmersiveSlideShowControls_ImmersiveSlideShowControls, {
    activeIndex: activeIndex + 1,
    isPaginationDisabled: isPaginationDisabled,
    nextLabel: nextLabel,
    onNext: function onNext(e) {
      return scroll(activeIndex + coef, e);
    },
    onPrev: function onPrev(e) {
      return scroll(activeIndex - coef, e);
    },
    previousLabel: previousLabel,
    slidesCount: items.length,
    theme: controlsTheme
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/ImmersiveSlideShow.jsx



var ImmersiveSlideShow_jsx = react_default.a.createElement;






var ImmersiveSlideShow_ImmersiveSlideShow = function ImmersiveSlideShow(_ref) {
  var _ref$immersiveSize = _ref.immersiveSize,
      immersiveSize = _ref$immersiveSize === void 0 ? 'large' : _ref$immersiveSize,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      nextLabel = _ref.nextLabel,
      _ref$pictureAltLabel = _ref.pictureAltLabel,
      pictureAltLabel = _ref$pictureAltLabel === void 0 ? '' : _ref$pictureAltLabel,
      previousLabel = _ref.previousLabel,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["immersiveSize", "media", "nextLabel", "pictureAltLabel", "previousLabel"]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!media.length) {
    return null;
  }

  var items = media.map(function (src, idx) {
    return ImmersiveSlideShow_jsx(ImmersiveSlideShowItem_ImmersiveSlideShowItem, Object(esm_extends["a" /* default */])({}, rest, {
      alt: Object(dist["messageFormat"])(pictureAltLabel).format({
        nb: idx + 1
      }),
      immersiveSize: immersiveSize,
      isImmersive: isDesktop,
      key: src,
      src: src
    }));
  });
  var controlsTheme = rest.controlsTheme,
      isPaginationDisabled = rest.isPaginationDisabled;
  return isDesktop ? ImmersiveSlideShow_jsx(ImmersiveSlideShowLarge_ImmersiveSlideShowLarge, {
    items: items,
    controlsTheme: controlsTheme,
    isPaginationDisabled: isPaginationDisabled,
    immersiveSize: immersiveSize,
    nextLabel: nextLabel,
    previousLabel: previousLabel
  }) : ImmersiveSlideShow_jsx(ImmersiveSlideShowNarrow_ImmersiveSlideShowNarrow, {
    items: items,
    controlsTheme: controlsTheme,
    isPaginationDisabled: isPaginationDisabled,
    nextLabel: nextLabel,
    previousLabel: previousLabel
  });
};

/***/ }),

/***/ "woxT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProgressBar_ProgressBar; });

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isInteger.js
var isInteger = __webpack_require__("RYcy");
var isInteger_default = /*#__PURE__*/__webpack_require__.n(isInteger);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.themes.js
var themes = {
  "default": {
    thRoot: 'bg-darkGrey leading-0 overflow-hidden relative',
    thBar: 'transition-width duration-250 ease-in h-2'
  },
  rounded: {
    thRoot: 'bg-lightSand leading-0 overflow-hidden relative rounded-pill',
    thBar: 'rounded-pill transition-width duration-250 ease-in h-15'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.jsx

var __jsx = react_default.a.createElement;




var ProgressBar_ProgressBar = function ProgressBar(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref$color,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 10 : _ref$max,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      value = _ref.value;

  if (!isInteger_default()(value) || value < 0) {
    return null;
  }

  var stepPercent = 100 / (max - min);
  var currentPercent = stepPercent * (value - min);
  var _themes$theme = themes[theme],
      thBar = _themes$theme.thBar,
      thRoot = _themes$theme.thRoot;
  return __jsx("div", {
    "aria-valuemax": max,
    "aria-valuemin": min,
    "aria-valuenow": value,
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    role: "progressbar"
  }, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thBar, "bg-".concat(color)),
    "data-testid": "progress-bar",
    style: {
      width: "".concat(currentPercent, "%")
    }
  }));
};

/***/ })

}]);